import I18n from 'I18n';
import { useQuery } from 'data-fetching-client';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { GET_ACTIVE_TRIALS, GET_ALL_TRIALS } from 'pricing-pages-api/trials/queries';
import { upgradeProductToTrialIds } from 'self-service-api/constants/Trials';
import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
const getTrialId = apiName => {
  const upgradeProduct = ApiNameToUpgradeProductMap[apiName];
  const trialId = upgradeProduct && upgradeProductToTrialIds[upgradeProduct];
  return trialId;
};
const useActiveTrials = ({
  skip
} = {}) => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  return useQuery(GET_ACTIVE_TRIALS, {
    skip: skip || !isAppAuth
  });
};
const useAllTrials = ({
  skip
} = {}) => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  return useQuery(GET_ALL_TRIALS, {
    skip: skip || !isAppAuth
  });
};
export const useAnyTrial = apiName => {
  const trialId = getTrialId(apiName);
  const {
    data,
    error,
    loading
  } = useAllTrials({
    skip: trialId === undefined
  });
  return {
    error,
    loading,
    trial: data === null || data === void 0 ? void 0 : data.allTrials.find(trial => {
      return trial.trial.id === trialId;
    })
  };
};
export const useCurrentTrial = apiName => {
  const trialId = getTrialId(apiName);
  const {
    data
  } = useActiveTrials({
    skip: trialId === undefined
  });
  return data === null || data === void 0 ? void 0 : data.activeTrials.find(activeTrial => {
    return activeTrial.trial.id === trialId;
  });
};
export const useDaysLeftInTrial = apiName => {
  const currentTrial = useCurrentTrial(apiName);
  if (!currentTrial) {
    return 0;
  }
  const endsAtTime = I18n.moment(currentTrial.endsAt);
  const hoursRemaining = endsAtTime.diff(I18n.moment(), 'hours');
  return hoursRemaining < 24 && hoursRemaining > 0 ? 1 : endsAtTime.diff(I18n.moment(), 'days');
};